import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lms_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(t) {
  if (t) localStorage.setItem("lms_token", t);
  else localStorage.removeItem("lms_token");
}
export function getToken() { return localStorage.getItem("lms_token"); }

export function saveUser(u) {
  if (u) localStorage.setItem("lms_user", JSON.stringify(u));
  else localStorage.removeItem("lms_user");
}
export function getUser() {
  try { return JSON.parse(localStorage.getItem("lms_user") || "null"); } catch { return null; }
}

export function logout() { setToken(null); saveUser(null); window.location.href = "/login"; }
